import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { Item, ShipStationOrder } from 'src/app/models/fbmOrders.model';

@Component({
  selector: 'app-ship-packing-slip',
  templateUrl: './ship-packing-slip.component.html',
  styleUrls: ['./ship-packing-slip.component.scss']
})
export class ShipPackingSlipComponent implements OnInit,OnDestroy {
  private destroy$ = new Subject<void>();

  constructor() { }

  ngOnInit(): void {
  }

  shipOrder:any=(orderNumber:any)=>{
    let index=this.shipOrders.findIndex((obj:any)=>obj.OrdersId===orderNumber || obj.Orderid==orderNumber);
    return this.shipOrders[index];
  }

  private _shipStationOrders:Array<ShipStationOrder>=new Array<ShipStationOrder>();
  @Input() public get shipStationOrders(){
   return this._shipStationOrders; 
  }

  public set shipStationOrders(value:any){
    this._shipStationOrders=value;
  }

  private _orderDetails:any;
  @Input() get orderDetails(){
    return this._orderDetails;
  }

  set orderDetails(value:any){
    this._orderDetails=value;
  }

  private _shipOrders:any;
  @Input() get shipOrders(){
    return this._shipOrders;
  }

  set shipOrders(value:any){
    this._shipOrders=value;
  }

  private _isSingle:boolean=false;
  @Input() get single():boolean{
    return this._isSingle;
  }

  set single(value:boolean){
    this._isSingle=value;
  }

  getSubTotal(element:ShipStationOrder):number{
    return element?.items?.map((item:Item)=>item.quantity*item.unitPrice)?.reduce((a,b)=> a+b);
  }

  getTax(element:ShipStationOrder):number{
    return element?.items?.map((item:Item)=>item.taxAmount)?.reduce((a,b)=> a+b);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
